function videoPlaylistHeight() {
  const height = $('.video-playlist__player .video-iframe').outerHeight()
  const padding = Number($('.video-playlist__player').css('padding-top').replace('px', '')) * 2

  if ($(window).width() >= 768) {
    $('.video-playlist__aside').css('height', height + padding)
  } else {
    $('.video-playlist__aside').removeAttr('style')
  }
}

if ($('.video-playlist').length > 0) {
  videoPlaylistHeight()
  $(window).on('load resize', videoPlaylistHeight)
}

$('.video-playlist__link').on('click', (e) => {
  const href = $(e.currentTarget).attr('href')

  e.preventDefault()

  $('.video-playlist__link').removeClass('is_active')
  $(e.currentTarget).addClass('is_active')

  $('.video-playlist__player iframe').attr('src', href)
})
